import { MobileMenu } from '@/features/header/mobile-menu';
import { withBasePath } from '@/utils/basePath';
import { navLinks } from '@/utils/data/nav-links';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { Fragment, useEffect, useState } from 'react';
import { Button } from '../ui/button';
import { useFeaturesCategory } from '@/providers/features-category.provider';

export default function Header() {
  const [isActive, setIsActive] = useState(false);
  const router = useRouter();
  const { goToFacturationElectronique, setActiveCategory } = useFeaturesCategory();

  useEffect(() => {
    document.body.style.overflow = isActive ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isActive]);

  return (
    <Fragment>
      <div className="border-dark-blue/[0.07] fixed z-60 w-screen backdrop-blur-lg">
        <div className="max-w-custom mx-auto flex h-24 w-full items-center justify-between px-8 py-6">
          <Link href="/" scroll={true} title="Page Home">
            <Image
              alt="Logo zLawyer"
              className="cursor-pointer"
              height={48}
              src={withBasePath('/images/logos/zeleLogo.png')}
              style={{ height: '3rem', width: 'auto' }}
              width={120}
              priority
            />
          </Link>

          {/* Desktop nav */}
          <ul className="hidden items-center gap-8 lg:flex">
            {navLinks.map((link, i) => (
              <li key={i}>
                <Button
                  className="text-md hover:text-orange whitespace-nowrap text-gray-700 transition-colors duration-200"
                  href={link.href}
                  target={link.target}
                  variant="transparent"
                  isAnchor
                  onClick={(event) => {
                    if (link.href !== '/#facturation-electronique') return;

                    event.preventDefault();

                    if (router.pathname !== '/') {
                      setActiveCategory('facturation');
                      void router.push(link.href, undefined, { scroll: false });
                      return;
                    }

                    goToFacturationElectronique();
                  }}
                >
                  {link.label}
                </Button>
              </li>
            ))}
            <li className="hidden 2xl:block">
              <Button href="tel:330184257027" variant="transparent">
                01 84 25 70 27
              </Button>
            </li>
            <li>
              <Button href="/contact/" variant="fill">
                Demandez une démo
              </Button>
            </li>
          </ul>

          <div className="block h-10 w-10 lg:hidden" />
        </div>
      </div>

      <button
        aria-label="Menu"
        className="fixed top-7 right-8 z-300 flex h-12 w-12 items-center justify-center lg:hidden"
        onClick={() => setIsActive((v) => !v)}
      >
        <span className="flex w-6 flex-col items-end justify-center gap-[5px]">
          <span
            className={[
              'bg-orange block h-[1.5px] origin-center rounded-sm transition-all duration-300',
              isActive ? 'w-6 translate-y-[6.5px] rotate-45' : 'w-6',
            ].join(' ')}
          />
          <span
            className={[
              'bg-orange block h-[1.5px] origin-center rounded-sm transition-all duration-300',
              isActive ? 'scale-x-0 opacity-0' : 'w-4 scale-x-100 opacity-100',
            ].join(' ')}
          />
          <span
            className={[
              'bg-orange block h-[1.5px] origin-center rounded-sm transition-all duration-300',
              isActive ? 'w-6 -translate-y-[6.5px] -rotate-45' : 'w-5',
            ].join(' ')}
          />
        </span>
      </button>

      <MobileMenu isActive={isActive} onClose={() => setIsActive(false)} />
    </Fragment>
  );
}
